// 必要なReactのフックとMaterial-UIのコンポーネントをインポート
import { useState } from 'react'; // ReactのuseStateフック
import { Box, Typography, Grid, IconButton } from '@mui/material'; // Material-UIのレイアウトやUIコンポーネント
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'; // 左矢印アイコン
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'; // 右矢印アイコン
import USItem from '../atoms/USItem'; // カスタムコンポーネントUSItemをインポート

/** 
 * USCollectionコンポーネント
 * ユーザーのサイトマップにおけるカテゴリの表示部品。
 * 初級コースなどのコンテンツを横スクロール形式で表示する。
 * @param windowWidth ウィンドウの幅（レスポンシブな表示調整に使用）
 */
const USCollection = ({ windowWidth }: { windowWidth: number }) => {
  // 表示するタイトル（例：新入社員向け・初級コース）
  const title = "〇新入社員向け・初級コース";

  // 表示する内容（仮のデータとして1を11個用意）
  const contents = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];

  // 現在のスクロール位置を管理するステート
  const [pos, setPos] = useState(0);

  // コンテンツを動かす際の1回の移動量（ピクセル単位）
  const move = 261;

  // コンポーネントの描画
  return (
    // ボックス全体の高さを指定、レスポンシブな幅を設定
    <Box height={'400px'} sx={{ maxWidth: windowWidth * 0.93 }}>
      {/* グリッドレイアウトを使用して全体を3分割 */}
      <Grid container maxWidth='100%'>
        {/* 左矢印ボタン */}
        <Grid item xs={1}>
          <Box paddingX='50%' paddingY='200px'>
            {pos < 0 && ( // posが0未満の場合に表示（左方向にさらにスクロール可能な場合）
              <IconButton onClick={() => setPos(pos + 1)}> {/* posを1つ戻す */}
                <ArrowBackIosNewIcon fontSize='large' />
              </IconButton>
            )}
          </Box>
        </Grid>
        {/* メインコンテンツ部分 */}
        <Grid item xs={10}>
          <Box sx={{ padding: '10px', maxWidth: '100%' }}>
            {/* タイトル部分 */}
            <Typography variant='h5'>
              {title}
            </Typography>
            <hr />
            {/* コンテンツを横スクロール表示 */}
            <Box overflow='hidden' maxWidth='100%'>
              <div
                style={{
                  display: 'flex', // 子要素を横に並べる
                  width: 'fit-content', // 子要素の幅に合わせる
                  transform: 'translateX(' + String(pos * move) + 'px)', // スクロール位置に応じた移動
                  transition: 'transform 0.3s ease', // スクロール時のアニメーション
                }}
              >
                {/* contents配列の要素ごとにUSItemコンポーネントを描画 */}
                {contents.map((item, index) => (
                  <USItem key={index} /> // 個別アイテムを表示（キーはindex）
                ))}
              </div>
            </Box>
          </Box>
        </Grid>
        {/* 右矢印ボタン */}
        <Grid item xs={1}>
          <Box paddingX='10px' paddingY='200px'>
            {pos > -(contents.length - 1) && ( // posが-(contents.length - 1)より大きい場合に表示（右方向にさらにスクロール可能な場合）
              <IconButton onClick={() => setPos(pos - 1)}> {/* posを1つ進める */}
                <ArrowForwardIosIcon fontSize='large' />
              </IconButton>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

// USCollectionコンポーネントをデフォルトエクスポート
export default USCollection;
